export const SUPPORT_FILE_DEFAULTS={
  fileContents: "",
  fileName: "",
  notes: ""
}

export const OUTPUT_SUPPORTING_FILES_DEFAULTS={
  correctDocFile: [],
  frequencyTablefile: [],
  sampleSizeFile: [],
  crossTabFile: [],
  subTotalsFile: [],
  unroundedFile: [],
  dominanceTestingFile: [],
  continuousVariablesSensitivityFile: [],
  other: []
}

export const OUTPUT_FILE_DEFAULTS={
  sheetName: "",
  datasetName: "",
  sampleUsed: "",
  geographyLevel: "",
  outputFile: "",
  outputMethods: {
    descriptiveMethod: false,
    scalingMethod: false,
    graphsMethod: false,
    regressionMethod: false,
    modelingMethod: false,
    otherMethod: false
  },
  includeWeightVariable: "",
  linkedData: "",
  descriptiveStats: "",
  equivalentDescriptiveStats: "",
  includeMatrix: "",
  roundingOutput: "",
  dominanceTestingOutput: "",
  economicDataOutput: "",
  uniqueDataUnits: "",
  outputContinuousVariables: "",
  continuousVariablesSensitivity:"",
  outputMethodDescription: "",
  weightVariableName: "",
  weightVariableType: "",
  linkedDataDescription: "",
  outputLabelled: "",
  minCellSize: "",
  continuousVariables: "",
  dichotomousVariables: "",
  correlatedVariables: "",
  roundingOutputDescription: "",
  supportingFiles: {...OUTPUT_SUPPORTING_FILES_DEFAULTS}
}

export const SUPPORTING_FILES_DEFAULTS={
  syntaxFile: [],
  variableListFile: [],
  other: [],
  previousRelease_residualTablesFile: [],
  previousRelease_bothSetsFile: []
}

export const REQUEST_FORM_DEFAULTS={
  requestName: "",

  consistentOutput: "",
  vettingRules: "",
  finalOutput: "",
  outputFilesFolder: "",

  outputFiles: [],
  supportingFiles: {...SUPPORTING_FILES_DEFAULTS},

  subsetVariables: "",
  subsetVariables_explainChanges: "",

  previousRelease: "",
  previousRelease_changedSubSample: "",
  previousRelease_droppedOutliers: "",
  previousRelease_imputedData: "",
  previousRelease_modifiedVariables: "",
  previousRelease_explainChanges: "",
  previousRelease_dateRelation: "",
  
  additionalComments: ""
}